import React from 'react';

export enum TabValue {
  editor = 1,
  view = 2,
  inventorization = 3,
}

interface TabPanelProps {
  children?: React.ReactNode;
  value: TabValue;
  index: TabValue;
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`terminal-config-tabpanel-${index}`}
      aria-labelledby={`terminal-config-tab-${index}`}
      style={{ display: value === index ? 'flex' : 'none', flex: 1, minHeight: 0, overflow: 'hidden' }}
      {...other}
    >
      {value === index && children}
    </div>
  );
}
